import { configureStore } from '@reduxjs/toolkit';
import carousalReducer from '../components/Carousal/CarousalSlice';
import loginReducer from '../pages/Login/LoginSlice';
import  producerRegistrationReducer from '../pages/SignUp/ProducerRegistrationSlice';
import termsConditionsReducer from '../components/TermsConditions/TermsConditionsSlice';
import producerApprovalRejectionReducer from '../pages/SystemAdminApproveRejectPage/ProducerApprovalRejectionSlice';
import createBriefReducer from '../pages/NewBrief/CreateBriefSlice';
import applyBriefReducer from '../pages/ApplyBrief/ApplyBriefSlice';

export const store = configureStore({
  reducer: {
    carousal:carousalReducer,
    login:loginReducer,
    producerRegistration:producerRegistrationReducer,
    termsConditions:termsConditionsReducer,
    ProducerApprovalRejection: producerApprovalRejectionReducer,
    createBrief: createBriefReducer,
    applyBrief: applyBriefReducer
  },
})